import script from "./Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout.vue?vue&type=script&lang=ts&setup=true"

import "./Layout.vue?vue&type=style&index=0&id=ddc3d49e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc3d49e"]])

export default __exports__